import React, { useContext, useEffect, useState } from 'react';
import { UncontrolledPopover, PopoverBody } from 'reactstrap';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, Typography } from '@material-ui/core';
import CloudIcon from '@material-ui/icons/Cloud';
import moment from 'moment';
import { Weather } from "../contexts/weatherContext";
import '../../css/common.css'

const useStyles = makeStyles(theme => ({
    root: {
        height: '310px',
        borderRadius: '10px',
        border: '2px solid #608094',
        background: 'rgba(73, 100, 115, 0.72156863)'
    },
    mobileView: {
        display: 'block',
        [theme.breakpoints.down('sm')]: {
            display: 'inline-flex'
        }
    },
    text: {
        [theme.breakpoints.down('sm')]: {
            marginLeft: '15px',
            fontSize: 'initial'
        }
    },
    pop: {
        backgroundColor: 'inherit',
        width: 'max-content',
        boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
        zIndex: 1400
    },
    location: {
        paddingTop: '15px',
        textAlign: 'center',
        fontWeight: 'bold'
    },
    week: {
        clear: 'both',
        paddingTop: '20px',
        textAlign: 'center'
    },
    day: {
        float: 'left',
        width: '97px',
        height: '100px',
        position: 'relative'
    },
    weekDayName: {
        fontWeight: '600',
        fontSize: '12px',
        display: 'block'
    },
    weekDayImage: {
        width: '40px'
    },
    weekDayTemperature: {
        position: 'absolute',
        bottom: '17px',
        width: '100% ',
        left: '2px',
        fontWeight: '600'
    },
    weatherLeft: {
        float: 'left',
        width: '250px',
        height: '135px',
        marginLeft: '20px'
    },
    weatherRight: {
        float: 'right',
        width: '185px',
        height: '135px',
        paddingTop: '26px'
    },
    pressure: {
        display: 'block',
        marginTop: '12px'
    },
    temperature: {
        position: 'absolute',
        left: '185px',
        top: '90px',
        fontSize: '32px'
    },
    description: {
        position: 'absolute',
        left: '80px',
        top: '150px'
    }
}));

const WeatherReport = () => {
    const classes = useStyles();
    const { weather } = useContext(Weather);
    const [forecastDays, setForecastDays] = useState([]);
    const [cityName, setCityName] = useState("");
    const [headerImage, setHeaderImage] = useState("");
    const [day1Image, setDay1Image] = useState("");
    const [day2Image, setDay2Image] = useState("");
    const [day3Image, setDay3Image] = useState("");
    const [day4Image, setDay4Image] = useState("");
    const [day5Image, setDay5Image] = useState("");
    
    const MathF = (temp) => {
        return Math.round((temp - 273.15) * 1.8 + 32) + " °f";
    };

    const setWeatherInfo = () => {
        if (weather.message === 0) {
            let keys = {};
            let daysForecast = [];
            let dayIndex = moment().weekday();
            let resultCount = weather.list.length - 1;
            let weekday = new Array(7);

            weekday[0] = "SUN";
            weekday[1] = "MON";
            weekday[2] = "TUE";
            weekday[3] = "WED";
            weekday[4] = "THU";
            weekday[5] = "FRI";
            weekday[6] = "SAT";

            weather.list.forEach((item, index) => {
                let date = item.dt_txt.substring(0, 10);
                let dateTime = date + " 09:00:00";

                if (!keys[date] && moment(item.dt_txt) > moment(dateTime)) {
                    keys[date] = date;

                    if (dayIndex === 7)
                        dayIndex = 0;

                    daysForecast.push({ key: date, values: item, thisWeekDay: weekday[dayIndex] });
                    dayIndex++;
                }

                //if last day no 12:00:00 PM
                if (resultCount === index && daysForecast.length === 5) {
                    if (dayIndex === 7)
                        dayIndex = 0;
                    daysForecast.push({ key: date, values: item, thisWeekDay: weekday[dayIndex] });
                }
            });

            setForecastDays(daysForecast);
            setCityName(weather.city.name);
            setHeaderImage("//openweathermap.org/themes/openweathermap/assets/vendor/owm/img/widgets/" + daysForecast[0].values.weather[0].icon + ".png");
            setDay1Image("//openweathermap.org/themes/openweathermap/assets/vendor/owm/img/widgets/" + daysForecast[1].values.weather[0].icon + ".png");
            setDay2Image("//openweathermap.org/themes/openweathermap/assets/vendor/owm/img/widgets/" + daysForecast[2].values.weather[0].icon + ".png");
            setDay3Image("//openweathermap.org/themes/openweathermap/assets/vendor/owm/img/widgets/" + daysForecast[3].values.weather[0].icon + ".png");
            setDay4Image("//openweathermap.org/themes/openweathermap/assets/vendor/owm/img/widgets/" + daysForecast[4].values.weather[0].icon + ".png");
            setDay5Image("//openweathermap.org/themes/openweathermap/assets/vendor/owm/img/widgets/" + daysForecast[5].values.weather[0].icon + ".png");
        }
        else {
            setForecastDays([]);
        }
    };

    useEffect(() => {
        setWeatherInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [weather]);

    return (<>
        <IconButton style={{ paddingTop: '0px', paddingBottom: '0px' }} color="inherit" id="PopoverWeather">
            <div className={classes.mobileView}>
                {(forecastDays.length === 0) && <>
                    <CloudIcon />
                    <Typography variant="caption" display="block">NA</Typography>
                </>}
                {(forecastDays.length > 0) && <>
                    <img style={{ width: "32px", height: "33px" }} src={headerImage} alt="" />
                    <Typography variant="caption" display="block" className={classes.text}>{MathF(forecastDays[0].values.main.temp)}</Typography>
                </>}
            </div>
        </IconButton >
        <UncontrolledPopover trigger="legacy" placement="bottom" target="PopoverWeather" className="popoverContainer">
            <PopoverBody style={{ color: "#FFFFFF" }}>
                <div className={classes.root}>
                    {(forecastDays.length > 0) && <>
                        <div className={classes.location}>
                            <span>{cityName}</span>
                        </div>
                        <div className={classes.weatherLeft}>
                            <img src={headerImage} alt="" />
                            <span className={classes.description}>{forecastDays[0].values.weather[0].main}</span>
                        </div>
                        <div className={classes.weatherRight}>
                            <span className={classes.pressure}>Wind: {parseFloat(forecastDays[0].values.wind.speed * 3.6).toFixed(2)} kmph</span>
                            <span className={classes.pressure}>Pressure: {forecastDays[0].values.main.pressure} mb</span>
                            <span className={classes.temperature}>{MathF(forecastDays[0].values.main.temp)}</span>
                        </div>
                        <div className={classes.week}>
                            <div className={classes.day}>
                                <span className={classes.weekDayName}>{forecastDays[1].thisWeekDay}</span>
                                <img className={classes.weekDayImage} src={day1Image} alt="" />
                                <span className={classes.weekDayTemperature}>{MathF(forecastDays[1].values.main.temp)}</span>
                            </div>
                            <div className={classes.day}>
                                <span className={classes.weekDayName}>{forecastDays[2].thisWeekDay}</span>
                                <img className={classes.weekDayImage} src={day2Image} alt="" />
                                <span className={classes.weekDayTemperature}>{MathF(forecastDays[2].values.main.temp)}</span>
                            </div>
                            <div className={classes.day}>
                                <span className={classes.weekDayName}>{forecastDays[3].thisWeekDay}</span>
                                <img className={classes.weekDayImage} src={day3Image} alt="" />
                                <span className={classes.weekDayTemperature}>{MathF(forecastDays[3].values.main.temp)}</span>
                            </div>
                            <div className={classes.day}>
                                <span className={classes.weekDayName}>{forecastDays[4].thisWeekDay}</span>
                                <img className={classes.weekDayImage} src={day4Image} alt="" />
                                <span className={classes.weekDayTemperature}>{MathF(forecastDays[4].values.main.temp)}</span>
                            </div>
                            <div className={classes.day}>
                                <span className={classes.weekDayName}>{forecastDays[5].thisWeekDay}</span>
                                <img className={classes.weekDayImage} src={day5Image} alt="" />
                                <span className={classes.weekDayTemperature}>{MathF(forecastDays[5].values.main.temp)}</span>
                            </div>
                        </div>
                    </>}
                </div>
            </PopoverBody>
        </UncontrolledPopover>
    </>
    )
}
export default React.memo(WeatherReport);
